import { PageRef } from 'providers/page-ref';

export type CoachClientDetailPageParams = {
  clientSlotId: string;
};

export interface CoachClientDetailPageResult {
  modified?: boolean;
}

export const ICoachClientDetailPage: PageRef<CoachClientDetailPageParams, CoachClientDetailPageResult | undefined> = {
  pageName: 'CoachClientDetailPage',
} as PageRef<CoachClientDetailPageParams, CoachClientDetailPageResult | undefined>;
